<template>
  <!--
    [ 히든 옵션 / default : hidden ]
    .view--btn-icon
    .view--label 
    .view--help-text

    [ 포커스 옵션 / default : hidden ]
    .focus--shadow
    .focus--border
    .focus--bg

    [ 라운드 옵션 / default : style--square ]
    .style--round 
    .style--square
    .style--radius-sm
    .style--radius-md
    .style--radius-lg

    [ 크기 옵션 / default : spacing--sm ]
    .spacing--xs
    .spacing--sm
    .spacing--md
    .spacing--lg 
    .spacing--xl 

    [ 레이아웃 옵션 / default : vertical ]
    .horizontal

    [ 라벨 옵션 / default : label--sm ]
    .label--sm
    .label--md
    .label--lg

    .label--left
    .label--center
    .label--right
  -->
  <div class="form-search-container OPTION view--btn-icon">
    <!-- <label class="form-label">{{label}}</label> -->
    <div class="form-group">
      <input
        class="form-input"
        type="text"
        :ref="name"
        :value="value"
        :placeholder="placeholder"
        :readonly="readonly"
        @input="input($event)"
      >
      <form-button
        class=""
        icon="search"
      ></form-button>
    </div>
    <form-error
      :name="name"
      :error="error"
    ></form-error>
    <help-text :label="helpText"></help-text>
  </div>
</template>

<script>
import focusOnError from '@/component/ui/focusOnError'

export default {
  mixins: [focusOnError],
  props: {
    value: { type: [String, Number] },
    name: { type: String, required: true },
    error: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    helpText: { type: String, default: '' }
  },
  data () {
    return {
      focus: false
    }
  },
  methods: {
    input ($event) {
      // console.log('$evnet', $event)
      this.$emit('input', this.type === 'number' ? Number($event.target.value) : $event.target.value)
    },
    clear () {
      this.$emit('input', this.type === 'number' ? 0 : '')
    }
  },
  components: {
    FormButton: () => import('@/component/ui2/button/FormButton'),
    FormError: () => import('@/component/ui2/form/FormError'),
    HelpText: () => import('@/component/ui2/common/HelpText')
  }
}
</script>
